import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { TransferProgress } from './api';

export const useDentalLoadingStore = defineStore('dental-loading', () => {
  const active = ref(false); const stage = ref(''); const percent = ref<number | null>(null);
  const received = ref(0); const total = ref<number | null>(null); const startedAt = ref(0);
  function step(name: string, progress: number | null = null) {
    stage.value = name; percent.value = progress; received.value = 0; total.value = null;
  }
  function begin() { active.value = true; startedAt.value = Date.now(); step('读取样本信息'); }
  function transfer(progress: TransferProgress) {
    received.value = progress.received; total.value = progress.total;
    percent.value = progress.total ? Math.min(100, Math.floor(progress.received / progress.total * 100)) : null;
  }
  function finish() { active.value = false; }
  return { active, stage, percent, received, total, startedAt, step, begin, transfer, finish };
});
